/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthResponse } from '../models/AuthResponse';
import type { OfferSignatureApple } from '../models/OfferSignatureApple';
import type { PurchaseVerificationRequest } from '../models/PurchaseVerificationRequest';
import type { Subscription } from '../models/Subscription';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PurchaseService {
    /**
     * Verify Purchase
     * Verify a purchase.
     * @param requestBody
     * @returns AuthResponse Successful Response
     * @throws ApiError
     */
    public static verifyPurchasePurchaseVerifyPost(
        requestBody: PurchaseVerificationRequest,
    ): CancelablePromise<AuthResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/purchase/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Subscriptions
     * @returns Subscription Successful Response
     * @throws ApiError
     */
    public static getSubscriptionsPurchaseSubscriptionsGet(): CancelablePromise<Array<Subscription>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase/subscriptions',
        });
    }
    /**
     * Google Play Webhook
     * @param token
     * @returns any Successful Response
     * @throws ApiError
     */
    public static googlePlayWebhookPurchaseWebhooksGooglePlayPost(
        token: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/purchase/webhooks/google-play',
            query: {
                'token': token,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Apple App Store Webhook
     * @returns any Successful Response
     * @throws ApiError
     */
    public static appleAppStoreWebhookPurchaseWebhooksAppleAppStorePost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/purchase/webhooks/apple-app-store',
        });
    }
    /**
     * Get Offer Signature Apple
     * @param productId
     * @param subscriptionOfferId
     * @returns OfferSignatureApple Successful Response
     * @throws ApiError
     */
    public static getOfferSignatureApplePurchaseOfferSignatureAppleGet(
        productId: string,
        subscriptionOfferId: string,
    ): CancelablePromise<OfferSignatureApple> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/purchase/offer_signature/apple',
            query: {
                'product_id': productId,
                'subscription_offer_id': subscriptionOfferId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
